var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFalkonChatLoginIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_160320",
    "data-name": "Group 160320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 171.517,
    height: 31.3,
    viewBox: "0 0 171.517 31.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-falkon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1894",
    "data-name": "Rectangle 1894",
    width: 171.517,
    height: 31.3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-falkon-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M82.016,0A12.975,12.975,0,0,0,70.033,8a14.581,14.581,0,0,1,8-.191,12.967,12.967,0,0,1,16.219.839A12.976,12.976,0,0,0,82.016,0Z",
    transform: "translate(-70.033)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-falkon",
    x1: -0.706,
    y1: 3.62,
    x2: -0.696,
    y2: 3.62,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#ffb300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    stopColor: "#ffa400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9f00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-falkon-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M1.918,55.937a1.918,1.918,0,1,0,0,3.835H8.309a1.918,1.918,0,1,0,0-3.835Z",
    transform: "translate(0 -55.937)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-falkon-2",
    y1: 4.599,
    x2: 0.024,
    y2: 4.599,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffac00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ff9400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ff8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160311",
    "data-name": "Group 160311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160310",
    "data-name": "Group 160310",
    clipPath: "url(#clip-path-falkon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M529.689,52.154a5.41,5.41,0,0,1,5.636-5.559,5.164,5.164,0,0,1,5.329,4.181H538.02a2.668,2.668,0,0,0-2.7-1.853,3.233,3.233,0,0,0,0,6.462,2.892,2.892,0,0,0,2.787-1.807h2.649a5.269,5.269,0,0,1-5.436,4.135,5.393,5.393,0,0,1-5.636-5.559",
    transform: "translate(-400.313 -35.214)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M582.415,47.411h2.42v4.15h4.273v-4.15h2.435v10.72h-2.435V53.889h-4.273v4.242h-2.42Z",
    transform: "translate(-440.161 -35.831)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M629.13,47.411h3.093l3.691,10.72h-2.573l-.643-1.9h-4.1l-.628,1.9h-2.481Zm2.91,6.661-1.317-4h-.138l-1.332,4Z",
    transform: "translate(-472.711 -35.831)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M670.726,49.509H667.74v-2.1h8.423v2.1h-3v8.622h-2.435Z",
    transform: "translate(-504.645 -35.831)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M230.127,46.533h6.362v1.18h-5.07v3.826h4.736V52.7h-4.736v4.99h-1.291Z",
    transform: "translate(-173.919 -35.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M270.272,46.533h1.515l4.289,11.161H274.72l-1-2.647h-5.389l-1,2.647h-1.355Zm3,7.334-2.2-5.836h-.1l-2.2,5.836Z",
    transform: "translate(-201.005 -35.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M324.326,46.533h1.291v10h4.815v1.164h-6.107Z",
    transform: "translate(-245.11 -35.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M374.606,57.694l-3.524-5.421-1.53,1.786v3.635H368.26V46.533h1.291v5.628h.1l4.751-5.628h1.611l-4.05,4.719,4.241,6.441Z",
    transform: "translate(-278.313 -35.168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M410.561,51.473a5.772,5.772,0,1,1,5.756,5.787,5.646,5.646,0,0,1-5.756-5.787m10.2,0a4.435,4.435,0,1,0-4.432,4.576,4.389,4.389,0,0,0,4.432-4.576",
    transform: "translate(-310.282 -34.526)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M476.755,46.533h1.323l5.836,8.913h.1V46.533h1.276V57.694h-1.371l-5.772-8.913h-.1v8.913h-1.291Z",
    transform: "translate(-360.308 -35.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M108.953,45.081a12.972,12.972,0,0,1-24.7,5.536,12.647,12.647,0,0,1-.5-1.212c.231.206.468.4.713.592a12.974,12.974,0,0,0,20.151-14.6,12.931,12.931,0,0,1,4.339,9.68",
    transform: "translate(-63.294 -26.754)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M105.353,29.544A12.976,12.976,0,0,1,87.047,41.369a12.632,12.632,0,0,1-3.3-2.145c4-11.257,13.037-7.695,13.037-7.695A11.664,11.664,0,0,0,88.469,24.4c-.025-.007-.049-.013-.074-.018a12.968,12.968,0,0,1,16.22.839,12.94,12.94,0,0,1,.739,4.324",
    transform: "translate(-63.294 -16.573)",
    fill: "#002d9e"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_160313",
    "data-name": "Group 160313",
    transform: "translate(17.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160312",
    "data-name": "Group 160312",
    clipPath: "url(#clip-path-falkon-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1895",
    "data-name": "Rectangle 1895",
    width: 24.215,
    height: 8.647,
    fill: "url(#linear-gradient-falkon)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_160315",
    "data-name": "Group 160315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160314",
    "data-name": "Group 160314",
    clipPath: "url(#clip-path-falkon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M23.362,99.755h6.391a1.917,1.917,0,0,1,0,3.835H23.362a1.917,1.917,0,1,1,0-3.835",
    transform: "translate(-16.206 -75.39)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M23.335,12.683h6.391a1.917,1.917,0,0,1,0,3.835H23.335a1.917,1.917,0,1,1,0-3.835",
    transform: "translate(-16.186 -9.585)",
    fill: "#1450ff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_160317",
    "data-name": "Group 160317",
    transform: "translate(0 13.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160316",
    "data-name": "Group 160316",
    clipPath: "url(#clip-path-falkon-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1897",
    "data-name": "Rectangle 1897",
    width: 10.226,
    height: 3.835,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-falkon-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkonChatLoginIcon);
export default __webpack_public_path__ + "static/media/falkon-chat-login-icon.d5b95a3b458eaf4fcb656f53339400bc.svg";
export { ForwardRef as ReactComponent };